import PropTypes from 'prop-types';
import { Layout } from 'antd';

const { Content } = Layout;

export const ContentCustom = ({ children, style, transparent }) => (
  <Content
    style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      padding: '24px',
      margin: '0 40px 32px',
      background: 'var(--componentBackground)',
      minHeight: 'fit-content',
      borderRadius: 'var(--ds-radius-xl, 16px)',
      boxShadow: 'var(--ds-shadow-card)',
      ...(transparent
        ? { background: 'transparent', padding: 0, boxShadow: 'none' }
        : {}),
      ...style
    }}
    className="content-custom"
  >
    {children}
  </Content>
);

ContentCustom.propTypes = {
  style: PropTypes.shape({}),
  transparent: PropTypes.bool
};

ContentCustom.defaultProps = {
  style: undefined,
  transparent: false
};
